import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-account-switch',
    templateUrl: './account-switch.component.html',
    styleUrls: ['./account-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSwitchComponent {
    @Input() checked = false;
    @Input() disabled = false;
    @Input() label = '';
    @Output() toggled = new EventEmitter<void>();

    onClick(): void {
        if (this.disabled) return;
        this.toggled.emit();
    }
}
